/**
 * PHARMAKON — audit log verbs & severity colors
 *
 * Ported from the design's config/audit-log.config.js. Consumed by the
 * audit explorer + AuditTrailTimeline component.
 *
 * X XWP-64 (XD-258): the journal's filters list the twin `@pharmakon/shared/constants/audit-journal.js`
 * (ActionAudit values the API accepts, the server's entity families); this table only carries the
 * tone and icon of each verb, the timeline's revision verbs included.
 */
import { FILTRE_ENTITES_AUDIT } from "@pharmakon/shared/constants/audit-journal.js";

export const AUDIT_ACTIONS = {
  LOGIN: { label: "Connexion", tone: "info", icon: "log-in" },
  LOGOUT: { label: "Déconnexion", tone: "neutral", icon: "log-out" },
  CREATE: { label: "Création", tone: "success", icon: "plus" },
  UPDATE: { label: "Modification", tone: "info", icon: "pencil" },
  DELETE: { label: "Suppression", tone: "danger", icon: "trash-2" },
  VALIDATE: { label: "Validation", tone: "success", icon: "check-circle" },
  CANCEL: { label: "Annulation", tone: "danger", icon: "x-circle" },
  STOCK_CORRECTION: {
    label: "Correction stock",
    tone: "warning",
    icon: "wrench",
  },
  PRINT: { label: "Impression", tone: "neutral", icon: "printer" },
  EXPORT: { label: "Export", tone: "neutral", icon: "download" },
  PERMISSION_DENIED: {
    label: "Accès refusé",
    tone: "danger",
    icon: "shield-x",
  },
  FAILED_LOGIN: {
    label: "Échec connexion",
    tone: "danger",
    icon: "shield-alert",
  },
  ACCESS: { label: "Consultation", tone: "neutral", icon: "eye" },
  // Trésorerie TWP-20 (UX 02 §12.3) — the revision actions of an operation (`ActionRevisionTresorerie`),
  // read by the operation drawer's « Historique » tab on the one AuditTrailTimeline.
  CREATION: { label: "Créée", tone: "success", icon: "plus-circle" },
  CONFIRMATION: { label: "Confirmée", tone: "success", icon: "check-circle-2" },
  MODIFICATION: { label: "Modifiée", tone: "info", icon: "history" },
  ANNULATION: { label: "Annulée", tone: "neutral", icon: "ban" },
  REPRISE: { label: "Reprise de l'ancien journal", tone: "neutral", icon: "rotate-ccw" },
};

/** The « Entité » filter's labels, by family (the twin's order). */
export const AUDIT_ENTITIES = Object.freeze(
  Object.fromEntries(FILTRE_ENTITES_AUDIT.map((o) => [o.value, o.libelle])),
);
